module.exports = __webpack_public_path__ + "img/overlap.0c1f0982.svg";